if (document.querySelector('form')) {
    // Default options
    const defaultOptions = {
        selectorButtonSubmit: '.formSubmit'
    };

    function initializeApplicationForm(formElement, optionsOverwrite = {}) {
        // Merge default options with provided options
        const options = Object.assign({}, defaultOptions, optionsOverwrite);

        const buttonSubmit = formElement.querySelector(options.selectorButtonSubmit);

        // Add event listener for form submission
        formElement.addEventListener('submit', function(e) {
            deactivateSubmitButton(buttonSubmit);
        });
    }

    function deactivateSubmitButton(button) {
        button.disabled = true;
    }

    // Usage
    const form = document.querySelector('form');
    initializeApplicationForm(form);
}


if (document.getElementById("NewsletterSuccessfullRegistered")) {
    // Cookie auf 3 Monate (90 Tage) setzen
    const maxAge = 90 * 24 * 60 * 60; // 90 Tage in Sekunden
    document.cookie = `popupSeen=dismissed; max-age=${maxAge}; path=/; SameSite=Lax`;
}
